$(window).ready(function () {

  if (window.location.href.indexOf("ring-mea-dev.myshopify.com/ar/") > -1) {
    var body = document.body;
    body.setAttribute("dir", "RTL")
  }

  $('.tabs-nav-item').click(function () {
    var link = $(this).data("tabs-link");
    var content = $(".tabs-wrapper .tabs-content-pane[data-tabs-content-pane='" + link + "']");
    if ($(this).hasClass('is-active')) {
      // $(this).toggleClass('is-active');
      // content.toggleClass('is-active');
    } else {
      $('.is-active').removeClass('is-active');
      $(this).toggleClass('is-active');
      content.toggleClass('is-active');
    }
  });

  $('.tab-component__tab').click(function () {
    var link = $(this).data("tabs-link");
    var content = $(".tab-component__tab-content[data-tabs-content-pane='" + link + "']");
    if ($(this).hasClass('is-active')) {
    } else {
      $('.is-active').removeClass('is-active');
      $(this).toggleClass('is-active');
      content.toggleClass('is-active');
    }
  });

  $('.new-ring-home .ring-protect__accordion-visible').click(function () {
    var imgId = '#' + $(this).data("img-link");
    $('.new-ring-home .ring-protect__accordion-img').removeClass('show');
    $(imgId).addClass('show');
  });

});
